import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import ProviderClientStatusModel from "../../models/provider-client-status";

export default class ProviderClientStatusRepository extends BaseRepository {
  static modelClass = ProviderClientStatusModel;
  modelName = "provider-client-status";
}
